import { render } from "./GenproxInput.vue?vue&type=template&id=5981cf29&scoped=true&ts=true"
import script from "./GenproxInput.vue?vue&type=script&lang=ts"
export * from "./GenproxInput.vue?vue&type=script&lang=ts"

import "./GenproxInput.vue?vue&type=style&index=0&id=5981cf29&lang=postcss&scoped=true"
/* custom blocks */
import block0 from "./GenproxInput.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5981cf29"]])

export default __exports__